export const defaultClubData = {
  clubCode: "",
  clubName: "",
  clubDesc: "",
  countryId: 0,
  logo: "",
  email: "",
  latitude: null,
  longitude: null,
  year: null,
  visibility: 0,
  createDate: ""
};

export const clubsTableHeaders = [
  {
    text: "Club Code",
    align: "left",
    sortable: true,
    value: "node.clubCode"
  },
  {
    text: "Club Desc",
    align: "left",
    sortable: true,
    value: "node.clubName"
  },
  {
    text: "Club Name",
    align: "left",
    sortable: true,
    value: "node.clubName"
  },
  { text: "Email", value: "node.email", sort: true },
  { text: "Number of groups", value: "node.groups", sort: true },
  { text: "Number of Athlete's", value: "node.athletes", sort: true },
  { text: "visibility", value: "node.visibility" },
  { text: "countryId", value: "node.countryId" },
  { text: "Club Id", value: "node.clubId" },
  { text: "Actions", value: "action", sortable: false }
];

export const clubNameValidationRules = [
  v => !!v || "Name is required",
  v => (v && v.length <= 50) || "Name must be less than 50 characters"
];

export const clubRequiredValidationRules = [v => !!v || "Value is required"];
export const regLatLngNumberValidationRule = [
  v =>
    /^([+-]?\d{1,2}[.]\d{5})|([-+]?\d{1,3}[.]\d{5})$/.test(v) ||
    "Wrong format number",
  v => !!v || "Value is required"
];
export const paginationSettings = {
  sortBy: "node.status",
  descending: false,
  rowsPerPage: -1
};
